<template>
  <div class="attractions-title-block">
    <h2 class="attractions-title">{{ title }}</h2>
    <AppLink v-if="showMoreButton && to" class="show-more" :to="to" target="_blank" @click="$emit('show-more-click')">
      {{ showMore }}
    </AppLink>
  </div>
</template>

<script setup lang="ts">
import type { RouterLinkProps } from 'vue-router';

withDefaults(
  defineProps<{
    title: string;
    showMore: string;
    showMoreButton?: boolean;
    to?: RouterLinkProps['to'];
  }>(),
  {
    showMoreButton: false,
  },
);

defineEmits<{
  (e: 'show-more-click'): void;
}>();
</script>

<style lang="scss" scoped>
.attractions-title-block {
  display: flex;
  align-items: baseline;
}

.attractions-title {
  margin-bottom: 24px;

  // @include base-700-700-semi;
  @include base-800-750-extra;

  @include mobile {
    margin-bottom: 16px;

    @include base-700-500-extra;

    // @include base-500-500-semi;
  }
}

.show-more {
  margin-left: 24px;
  color: var(--alias-color-link-default);
  white-space: nowrap;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }

  @include base-400-400-regular;

  @include tablet {
    display: none;
  }
}
</style>
